import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Plus, X, Phone, Mail, MapPin, Search } from "lucide-react";
import { Link } from "react-router-dom";

export default function Customers() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const [form, setForm] = useState({ name: "", phone: "", email: "", address: "", notes: "" });

  async function load() {
    const { data } = await api.get("/customers");
    setItems(data);
  }
  useEffect(() => { load(); }, []);

  async function submit(e) {
    e.preventDefault();
    const payload = { ...form, email: form.email || null };
    await api.post("/customers", payload);
    setOpen(false);
    setForm({ name: "", phone: "", email: "", address: "", notes: "" });
    load();
  }

  const filtered = items.filter((c) =>
    [c.name, c.phone, c.email, c.address].join(" ").toLowerCase().includes(q.toLowerCase())
  );

  return (
    <div className="p-8 lg:p-10" data-testid="customers-page">
      <header className="mb-8 flex items-end justify-between gap-4 flex-wrap">
        <div>
          <div className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-500 mb-2">CRM</div>
          <h1 className="font-display text-4xl font-semibold tracking-tight">Customers</h1>
        </div>
        <div className="flex items-center gap-3">
          <div className="relative">
            <Search className="w-4 h-4 absolute left-3 top-2.5 text-slate-400" />
            <input
              data-testid="customers-search"
              placeholder="Search customers…"
              value={q} onChange={(e) => setQ(e.target.value)}
              className="pl-9 pr-3 py-2 rounded-md border border-slate-300 text-sm outline-none focus:border-blue-500 w-64"
            />
          </div>
          <button onClick={() => setOpen(true)} data-testid="add-customer-btn"
            className="inline-flex items-center gap-2 bg-slate-900 hover:bg-slate-800 text-white text-sm px-3 py-2 rounded-md transition-colors">
            <Plus className="w-4 h-4" /> Add Customer
          </button>
        </div>
      </header>

      <div className="bg-white border border-slate-200 rounded-md overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 border-b border-slate-200">
            <tr className="text-left text-xs font-semibold uppercase tracking-wider text-slate-500">
              <th className="px-6 py-3">Name</th>
              <th className="px-6 py-3">Phone</th>
              <th className="px-6 py-3">Email</th>
              <th className="px-6 py-3">Address</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {filtered.length === 0 && (
              <tr><td colSpan={4} className="px-6 py-12 text-center text-slate-500" data-testid="customers-empty">
                No customers yet. Add your first customer to get started.
              </td></tr>
            )}
            {filtered.map((c) => (
              <tr key={c.id} data-testid={`customer-row-${c.id}`} className="hover:bg-slate-50 transition-colors">
                <td className="px-6 py-3 font-medium">
                  <Link to={`/customers/${c.id}`} className="text-slate-900 hover:text-blue-600">{c.name}</Link>
                </td>
                <td className="px-6 py-3 text-slate-600">{c.phone && <span className="inline-flex items-center gap-1"><Phone className="w-3 h-3"/>{c.phone}</span>}</td>
                <td className="px-6 py-3 text-slate-600">{c.email && <span className="inline-flex items-center gap-1"><Mail className="w-3 h-3"/>{c.email}</span>}</td>
                <td className="px-6 py-3 text-slate-600">{c.address && <span className="inline-flex items-center gap-1"><MapPin className="w-3 h-3"/>{c.address}</span>}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {open && (
        <div className="fixed inset-0 bg-slate-900/40 z-50 flex items-center justify-center p-4" onClick={() => setOpen(false)}>
          <div className="bg-white rounded-md w-full max-w-md p-6" onClick={(e) => e.stopPropagation()} data-testid="add-customer-modal">
            <div className="flex items-center justify-between mb-4">
              <h3 className="font-display text-xl font-semibold">New Customer</h3>
              <button onClick={() => setOpen(false)} data-testid="close-customer-modal"><X className="w-4 h-4 text-slate-500"/></button>
            </div>
            <form onSubmit={submit} className="space-y-3">
              {["name", "phone", "email", "address"].map((k) => (
                <input key={k} required={k === "name"} placeholder={k[0].toUpperCase()+k.slice(1)}
                  data-testid={`customer-${k}`}
                  value={form[k]} onChange={(e) => setForm({ ...form, [k]: e.target.value })}
                  className="w-full px-3 py-2 rounded-md border border-slate-300 text-sm outline-none focus:border-blue-500"/>
              ))}
              <textarea placeholder="Notes" data-testid="customer-notes"
                value={form.notes} onChange={(e) => setForm({ ...form, notes: e.target.value })}
                className="w-full px-3 py-2 rounded-md border border-slate-300 text-sm outline-none focus:border-blue-500" rows={3}/>
              <button type="submit" data-testid="customer-submit"
                className="w-full bg-slate-900 hover:bg-slate-800 text-white text-sm font-medium py-2.5 rounded-md transition-colors">
                Save Customer
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
